import React, { useState } from "react"
import { getCurrentSchoolYear } from "utils/general"
import { Outlet } from "react-router-dom"

export const popupKeys = { createVersion: "createVersion", recalculateAssessment: "recalculateAssessment" }

const TranscriptionSystem = () => {
    const [status, setStatus] = useState(null)
    const [assessmentFilters, setAssessmentFilters] = useState({
        school_year: getCurrentSchoolYear()
    })
    const [popups, setPopups] = useState({
        [popupKeys.createVersion]: false,
        [popupKeys.recalculateAssessment]: false
    })

    const commonState = {
        status, setStatus,
        popups, setPopups,
        assessmentFilters, setAssessmentFilters
    }

    return (
        <TranscriptionSystemContext.Provider value={commonState}>
            <Outlet />
        </TranscriptionSystemContext.Provider>
    )
}

export const TranscriptionSystemContext = React.createContext()
export default TranscriptionSystem